import { Pipe, PipeTransform } from '@angular/core';

/**
 * replaceCharsPipe
 */
@Pipe({
  name: 'replaceChars',
  pure: true,
  standalone: false,
})
export class ReplaceCharsPipe implements PipeTransform {
  transform(value: string, strToReplace: string, replacementStr: string): string {
    if (!value || !strToReplace || !replacementStr) {
      return value;
    }

    return value.replace(new RegExp(strToReplace, 'g'), replacementStr);
  }
}
